import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/clipboard-list.vue
var o = {
	name: "DtIconClipboardList",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--clipboard-list"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Clipboard List",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M3.5 1.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1H9A1.5 1.5 0 0 1 10.5 3v7A1.5 1.5 0 0 1 9 11.5H3A1.5 1.5 0 0 1 1.5 10V3A1.5 1.5 0 0 1 3 1.5h.5Zm4 2a1 1 0 0 0 1-1H9a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5h.5a1 1 0 0 0 1 1h3Zm-3-2h3v1h-3v-1Z",
		fill: "currentColor"
	}, null, -1), r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M5.5 5.5A.5.5 0 0 1 6 5h2a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Zm0 2.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Zm-2-2.5A.5.5 0 0 1 4 5h.005a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5Zm0 2.5a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=clipboard-list.js.map